import { ChatResponseChoice } from '@quicktools/shared-components/services/chatApi/types';

import { CATEGORIES } from '../../constants/tool-categories';

const newLineStart = /^[\n]|^.{0,1}[\n]/;
const start =
  /^((.{0,5})generate(.{0,20}):|^(.{0,10})text(.{0,10}):|^(.{0,25})bio(.{0,10}):|^(.{0,20})ad(.{0,10}):|^(.{0,15})phrase(.{0,10}):|^(.{0,17})media(.{0,10}):|^(.{0,10})marketing(.{0,10}):|^(.{0,20})slogan(.{0,10}):)[\n]?| */i;
const end = /[\n]$/;

const variantNumberRegex =
  /^[0-9]+\.|[\n][0-9]+\.|^[0-9]+:|[\n][0-9]+:|^[0-9]+\)|[\n][0-9]+\)|^[0-9]+ -|[\n][0-9]+ -|Variant [0-9]+:?|Variant #[0-9]+:?|Caption [0-9]+:?|^#[0-9]+[ ]|[\n]#[0-9]+[ ]/;

export const removePrefixes = (text: string) => {
  text = text
    .replaceAll('\n\n', '\n')
    .replace(newLineStart, '')
    .replace(start, '')
    .replace(end, '');

  return text;
};

export const manageChoices = (
  selectedCategory: number,
  splitChoices: boolean,
  choices: ChatResponseChoice[],
) => {
  const firstChoice = choices[0];

  if (splitChoices) {
    const content = removePrefixes(firstChoice.message.content)
      .split(variantNumberRegex)
      .filter((element) => element !== '' && element !== ' ' && element !== '\n');

    return content.map((element) => ({
      label: firstChoice.finish_reason,
      text: element,
    }));
  }

  const formatFn = CATEGORIES[selectedCategory].formatResults;

  return choices.map((choice) => ({
    label: choice.finish_reason,
    text: formatFn ? formatFn(choice.message.content) : choice.message.content,
  }));
};
